import React, { createContext, useEffect, useState } from 'react';
import { Button } from 'antd';

interface Props {
  visible: boolean;
  handlerSetVisibile: Function;
  children?: React.ReactElement;
  elementAbsolute?: React.ReactElement;
}

const RightScenes = (props: Props) => {
  useEffect(() => {
    document.body.style.overflowY = (props.visible)? "hidden" : "scroll";
  }, [props.visible])

  const closeModal = () => {
    document.body.style.overflowY = "scroll";
    props.handlerSetVisibile(false);
  }
  
  if(!props.visible) return null;

  return props.visible && (
    <div className="right-scenes">
      <div className={`right-scenes-content`} style={{ width: '80%' }}>
      {props.elementAbsolute}
        <div className="content-modal">
          <div className="modal-review-task__content">
            <div className="modal-title">
              <div className="flex-btw">
                <h3 className="body-card body-card-w6">
                  Hola
                </h3>
                <Button
                  className="body-card"
                  onClick={closeModal}
                >
                  Close X
                </Button>
              </div>
            </div>
          </div>
          <div className="modal-container">
            <div className="modal-cards modal-cards--full">
              <div className="modal-cards-mx-w">
                <div className="flex-btw">
                  Hola 2
                </div>
                {props.children}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Button
        className="button-close-mask"
        style={{ width: '20%', marginLeft: 10 }}
        onClick={closeModal}
      />

    </div>

  );
};
export default RightScenes;
